import { Button, Checkbox, Col, Divider, Form, Input, Row, Space } from "antd";
import { useEffect, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { atualizarBanco, cadastrarBanco } from "../../../../services/bancoService";
import { BancoModel } from "../../../../models/banco/bancoModel";
import { setModalCadastrarBanco } from "../../../../redux/slices/banco/bancoSlice";

const CadastroEdicaoBanco = () => {
  //estados globais
  const bancoState = useAppSelector((state) => state.banco);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<BancoModel>();

  const editar = Object.values(bancoState.entity).length !== 0;

  const inputInicial = useRef<any>(null);

  useEffect(() => {
    if (inputInicial.current && !editar) {
      inputInicial.current.focus();
    }
    if (editar) {
      form.setFieldsValue({
        ...bancoState.entity,
      });
    } else {
      form.setFieldsValue({ ativo: true });
    }
  }, [bancoState.entity]);

  const submit = (values: any) => {
    if (editar) {
      const updateBanco = { id: bancoState.entity.id, ...values };
      dispatch(atualizarBanco({ value: updateBanco, busca: bancoState.busca }));
    } else {
      dispatch(cadastrarBanco({ value: values, busca: bancoState.busca }));
    }
  };

  const voltar = () => {
    dispatch(setModalCadastrarBanco(false));
  };

  return (
    <Form form={form} layout="vertical" onFinish={submit}>
      <Row gutter={12}>
        <Col span={20}>
          <Form.Item
            label="Nome do Banco"
            name="denominacao"
            className="denominacaoFeriado"
            rules={[
              {
                required: true,
                message: "Digite o banco",
              },
            ]}
          >
            <Input type="text" ref={inputInicial} />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            label="Abreviatura"
            name="abreviatura"
            rules={[
              {
                required: true,
                message: "Digite a abreviatura",
              },
            ]}
          >
            <Input type="text" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={18}>
          <Form.Item
            label="Código"
            name="codigoBanco"
            rules={[
              {
                required: true,
                message: "Digite o código",
              },
            ]}
          >
            <Input type="text" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item name="ativo" label="Situação" valuePropName="checked">
            <Checkbox value="1" style={{ lineHeight: "32px" }}>
              Ativo
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastroEdicaoBanco;
